module.exports = __webpack_public_path__ + "img/oa1.b6f305d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/oa1.png
// module id = LMGV
// module chunks = 11